import { mutator } from 'satcheljs';
import { setAnnouncement, setPoliteAnnouncement } from '../actions';
import getStore from '../store';

mutator(setAnnouncement, ({ announcement }) => {
    const store = getStore();
    store.announcement = adjustAnnouncement(announcement, store.announcement);
});

mutator(setPoliteAnnouncement, ({ announcement }) => {
    const store = getStore();
    store.politeAnnouncement = adjustAnnouncement(announcement, store.politeAnnouncement);
});

function adjustAnnouncement(newAnnouncement: string, originalAnnouncement: string): string {
    // If the same announcement is sent, like setting the same color in two assets in sequence,
    // then we need to make the string slightly different in order to have the second announcement read.
    return newAnnouncement + (originalAnnouncement == newAnnouncement ? '.' : '');
}
